import { State } from 'editor/src/store/canvas/types';

const getCanvasHeight = (state: State) => state.canvas.height;

export default getCanvasHeight;
